import AppAuth from 'components/app/AppAuth';
import AppBar from 'components/common/controls/navbar/AppBar';
import BidConfirmation from 'components/confirmTransaction/BidConfirmation';
import PaymentConfirmation from 'components/confirmTransaction/PaymentConfirmation';
import restrictRoute from 'components/guards/router/RestrictRoute';
import ModalContainer from 'components/modal/ModalContainer';
import { RouteTo } from 'lib/utils/routing';
import OneTimeSetup from 'pages/auth/login/components/login-form/OneTimeSetup';
import { LoginPage } from 'pages/auth/login/Login.page';
import LogoutPage from 'pages/auth/logout/Logout.page';
import CampaignDashboard from 'pages/campaign/CampaignsDashboard/CampaignDashboard';
import CampaignsPage from 'pages/campaign/CampaignsPage/Campaigns';
import ShowcaseCampaigns from 'pages/campaign/CampaignsPage/ShowcaseCampaigns';
import CheckoutPage from 'pages/campaign/SellPage/Checkout';
import Receipt from 'pages/campaign/SellPage/Receipt';
import LandingPage from 'pages/Landing.page';
import React, { Component } from 'react';
import { withCookies } from 'react-cookie';
import Helmet from 'react-helmet';
import { Provider } from 'react-redux';
import { Route, Router, Switch } from 'react-router';
import { Elements } from 'react-stripe-elements';
import { history, store } from 'stores/store.js';
import styled from 'styled-components';
import './app.css';
import UsernameLinkOrPageNotFound from './PageNotFound'
import PaymentSetup from './StripeConnect/PaymentSetup';

import { API_ENDPOINTS, fetchAPI } from 'components/graphql/FetchApi'
import { findCampaignById, findCampaignBySubdomain } from 'components/graphql/queries'

const AppDiv = styled.div`
	min-height: 100vh !important;
`;

/**
 * Main routing component.
 */
class App extends Component<{ [label: string]: any }, { [label: string]: any }> {

	constructor(props) {
		super(props);
		this.state = {
			title: 'ISOTOPE | My Events',
			subdomain: ''
		}
	}

	// Choosing page title
	public componentDidMount() {

		const url = window.location.href.toLowerCase();
		const urlItems = url.split('/')
		const subdomain = urlItems[2].split('.')[0]
		this.setState({ subdomain })

		if ((subdomain !== 'app' && subdomain !== 'localhost:3000' && subdomain !== 'test')) {
			// PROD ONLY
			fetchAPI
				.post(API_ENDPOINTS.BASE_URL, {
					query: findCampaignBySubdomain,
					variables: {
						subdomain
					}
				})
				.then(res => {
					this.setState({
						title: 'ISOTOPE | ' + res.data.data.campaign.findBySubdomain.name
					})
				})
				.catch(err => {
					console.log(err)
				})
		} else if (window.location.pathname.includes('/sell/')) {
			// LOCAL ONLY
			const urlSplit = window.location.pathname.split('/')
			const sub = urlSplit[2]
			fetchAPI
				.post(API_ENDPOINTS.BASE_URL, {
					query: findCampaignBySubdomain,
					variables: {
						subdomain: sub
					}
				})
				.then(res => {
					this.setState({
						title: 'ISOTOPE | ' + res.data.data.campaign.findBySubdomain.name
					})
				})
				.catch(err => {
					console.log(err)
				})

		} else if (window.location.pathname.includes('/campaign/')) {
			const urlSplit = window.location.pathname.split('/')
			const id = urlSplit[2]
			fetchAPI
				.post(API_ENDPOINTS.BASE_URL, {
					query: findCampaignById,
					variables: {
						id
					}
				})
				.then(res => {
					this.setState({
						title: 'ISOTOPE | ' + res.data.data.campaign.findById.name
					})
				})
				.catch(err => {
					console.log(err)
				})
		} else if (window.location.pathname.includes('/receipt/')) {
			this.setState({
				title: 'ISOTOPE | Order Confirmed'
			})
		} else if (window.location.pathname.includes('/login')) {
			this.setState({
				title: 'ISOTOPE | Login'
			})
		}
	}

	public render() {
		const subdomain = this.state.subdomain;
		return (
			<Router history={history} >
				<Provider store={store}>
					<Elements>
						<AppDiv className={window.location.pathname.includes('/receipt/') ? 'receiptWhiteBackground app zoomOut' : 'app zoomOut'}>

							{/* html metadata */}
							<Helmet
								title={this.state.title}
								meta={[
									{ name: 'author', content: "ISOTOPE ticketing" },
									{ name: 'viewport', content: 'width=device-width, initial-scale=1, shrink-to-fit=yes' },
									{ property: 'og:title', content: 'ISOTOPE Ticketing' },
									{ property: 'og:site_name', content: "ISOTOPE" },
									{ property: 'og:image', content: "https://www.isotopeticketing.com/images/og-image.jpg" },
									{ property: 'og:site_name', content: "ISOTOPE" },
									{ property: 'og:image:width', content: '1428' },
									{ property: 'og:image:height', content: '748' },
									{ property: 'theme-color', content: '#000000' },
									{ property: 'charset', content: 'utf-8' },
									{ property: "google-site-verification", content: "zGFGX-x2yPoIdPnYyLJSxqwLu1gDg_OcKKahDfBpqMY" },
									{ property: "og:image:secure_url", content: "https://www.isotopeticketing.com/images/og-image.jpg" },
									{ property: 'description', content: 'Isotope Ticketing & Event Management Platform' },
								]}
							/>

							{/* Modal */}
							<ModalContainer />

							{/* Check for whether user is logged in already using cookie data */}
							<AppAuth />

							{/* Navbar */}
							<div className={
								(subdomain !== 'app' && subdomain !== 'localhost:3000' && subdomain !== 'test') || window.location.pathname.includes('/receipt/') || window.location.pathname.includes('/sell/') || window.location.pathname.includes('/showcase/')
									? '' : 'stick'
							}>
								<AppBar />
							</div>

							{/* All routes */}
							<div className='mainpage'
								style={{
									paddingTop: (subdomain !== 'app' && subdomain !== 'localhost:3000' && subdomain !== 'test') || window.location.pathname.includes('/receipt/') || window.location.pathname.includes('/sell/') || window.location.pathname.includes('/showcase/') ?
										'55px' : '110px'
								}}
							>
								<Switch>

									{/* Public routes */}

									<Route exact={true} path='/' component={LandingPage} />
									<Route exact={true} path='/login' component={LoginPage} />
									<Route exact={true} path='/logout' component={LogoutPage} />

									{/* Stripe after connect express setup redirect component */}
									<Route
										path='/paymentCallBack'
										component={PaymentSetup}
									/>

									<Route
										exact={true}
										path={RouteTo.receipt(':orderId')}
										component={Receipt}
									/>

									<Route
										exact={true}
										path={RouteTo.campaigns()}
										component={restrictRoute(CampaignsPage)}
									/>

									{/* payment confirmation component for new stripe checkout */}
									<Route
										path={RouteTo.paymentConfirmation(
											':name', ':email', ':phoneNumber', ':code', ':campaignId', ':sellerId', ':orderComponents',
											':floorplanLocationX', ':floorplanLocationY', ':address'
										)}
										component={PaymentConfirmation}
									/>

									{/* bid confirmation component for new stripe checkout */}
									<Route
										path={RouteTo.bidConfirmation(
											':name', ':email', ':phoneNumber', ':bidId', ':bid', ':campaignId', ':sellerId',
											':floorplanLocationX', ':floorplanLocationY', ':address', ':createdBy', ':username', ':subdomain'
										)}
										component={BidConfirmation}
									/>

									<Route
										exact={true}
										path={RouteTo.campaignDashboard(':campaignId')}
										component={restrictRoute(CampaignDashboard)}
									/>

									{/* LOCALHOST ONLY */}
									<Route
										exact={true}
										path={RouteTo.sellPage(':subdomain', ':username')}
										component={CheckoutPage}
									/>

									{/* LOCALHOST ONLY */}
									<Route
										exact={true}
										path={RouteTo.ownerSellPage(':subdomain')}
										component={CheckoutPage}
									/>

									<Route
										exact={true}
										path={RouteTo.setup(':userId')}
										component={OneTimeSetup}
									/>

									<Route
										exact={true}
										path={RouteTo.showcase(':username')}
										component={ShowcaseCampaigns}
									/>

									{/* EITHER ROUTES TO AFFILIATE LINK OR GIVES PAGE NOT FOUND*/}
									<Route
										component={UsernameLinkOrPageNotFound}
									/>

								</Switch>
							</div>
						</AppDiv>
					</Elements>
				</Provider>
			</Router >
		);
	}
}

export default withCookies(App);



// WEBPACK FOOTER //
// ./src/components/app/App.tsx